module.exports = __webpack_public_path__ + "img/HSBC_MASTER_LOGO.cd95de8f.svg";